import { api } from './api';

export interface SiteSetting {
  id: number;
  key: string;
  value: string;
  label: string;
  type: 'text' | 'textarea' | 'phone' | 'url';
  group: string;
}

export const settingsService = {
  getAll: async () => {
    return await api.get('/api/admin/settings');
  },
  
  updateMultiple: async (settings: Record<string, string>) => {
    return await api.put('/api/admin/settings', { settings });
  }
};
